import { useIsFreeCompanyAccount } from 'hooks/company/useCompanyAccountType';
import { useTranslation } from 'react-i18next';
import {
  ProposeModal,
  useOpenProposeModal,
} from 'screens/company-user/job/job-v1/propose-candidate/propose-modal/ProposeModal';

import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';

import { Job } from '@libs/graphql-types';

export function ProposeCandidate({ job }: { job: Job }) {
  const isFreeCompanyAccount = useIsFreeCompanyAccount();
  const { t } = useTranslation('job');
  const open = useOpenProposeModal();

  return (
    <div>
      <Button
        onClick={() => open()}
        startIcon={<AddIcon />}
        disabled={isFreeCompanyAccount}
        color="info"
        variant="outlined"
      >
        {t('v1.proposeModal.addCandidate')}
      </Button>
      <ProposeModal job={job} />
    </div>
  );
}
